import { render, staticRenderFns } from "./OperationConfigDetailBook.vue?vue&type=template&id=0f19243c&scoped=true"
import script from "./OperationConfigDetailBook.vue?vue&type=script&lang=js"
export * from "./OperationConfigDetailBook.vue?vue&type=script&lang=js"
import style0 from "./OperationConfigDetailBook.vue?vue&type=style&index=0&id=0f19243c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f19243c",
  null
  
)

export default component.exports